import React from "react";
import DataTable from "react-data-table-component";
import { useSelector, useDispatch } from "react-redux";
import { change_Lang } from "../../actions/Helper_action";
const CustomDataTable = ({ data, columns, rest }) => {
  const dispatch = useDispatch();
  const lang = useSelector((state) => state.HelperReducer.lang);
  const customStyles = {
    header: {
      style: {
        minHeight: "0.1px",
        background: "#e3e9f2",
      },
    },
    headRow: {
      style: {
        background: "#e3e9f2",
      },
    },
    headCells: {
      style: {
        color: "black",
        fontSize: "14px",
      },
    },
  };
  return (
    <DataTable
      columns={columns}
      data={data}
      {...rest}
      customStyles={customStyles}
      noDataComponent={dispatch(change_Lang("table_display"))}
      striped
      className={`${lang === "en" ? "" : "fk"}`}
      pagination={true}
    />
  );
};

export default CustomDataTable;
